// ---------------------------------------------------------------------------
// Fechas relativas de las consolas de personal (CC-CONSOLE#1595): «hace 3 días»,
// «en 2 semanas», y la antigüedad de una persona («2 a 4 m»). Usa
// Intl.RelativeTimeFormat con el idioma de la interfaz; sin dependencias.
// ---------------------------------------------------------------------------

const DAY = 86400000;

/** `YYYY-MM-DD` o ISO → ms (las fechas cortas se leen a mediodía UTC, sin saltos de zona). */
function toMs(value: string): number {
  return /^\d{4}-\d{2}-\d{2}$/.test(value) ? Date.parse(`${value}T12:00:00Z`) : Date.parse(value);
}

/** «hace 3 días», «en 2 semanas», «hoy». `null` si la fecha no se puede leer. */
export function relativeFrom(value: string | null | undefined, lang: string, now: number = Date.now()): string | null {
  if (!value) return null;
  const ms = toMs(value);
  if (!Number.isFinite(ms)) return null;
  const diffDays = Math.round((ms - now) / DAY);
  const rtf = new Intl.RelativeTimeFormat(lang.startsWith("en") ? "en" : "es", { numeric: "auto" });
  const abs = Math.abs(diffDays);
  if (abs < 7) return rtf.format(diffDays, "day");
  if (abs < 35) return rtf.format(Math.round(diffDays / 7), "week");
  if (abs < 365) return rtf.format(Math.round(diffDays / 30), "month");
  return rtf.format(Math.round(diffDays / 365), "year");
}

/** Antigüedad desde la fecha de ingreso, en años y meses: `{ years, months }`. */
export function tenure(hireDate: string | null | undefined, now: number = Date.now()): { years: number; months: number } | null {
  if (!hireDate) return null;
  const ms = toMs(hireDate);
  if (!Number.isFinite(ms) || ms > now) return null;
  const totalMonths = Math.floor((now - ms) / (DAY * 30.4375));
  return { years: Math.floor(totalMonths / 12), months: totalMonths % 12 };
}

/** Monto corto para un indicador: «MXN 412.5 mil». `—` si no hay número. */
export function compactMoney(amount: number | null | undefined, currency = "MXN"): string {
  if (amount === null || amount === undefined || !Number.isFinite(Number(amount))) return "—";
  const n = new Intl.NumberFormat("es-MX", { notation: "compact", maximumFractionDigits: 1 }).format(Number(amount));
  return `${currency} ${n}`;
}
